module.exports = __webpack_public_path__ + "img/CoinShine_static.734caaa8.gif";